import { useState } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, FormGroup, Input, Label, Button } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser } from '@fortawesome/free-solid-svg-icons';

import { translations } from './../i18/translations.js';
import styles from './Login.module.css';

const Login = ({ user, onUserChange, lang, setGrowlMessage }) => {

    const API_URL = process.env.REACT_APP_SERVICE_API_URL;

    //login
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    //forgot pwd
    const [email, setEmail] = useState('');

    const [forgotPwd, setForgotPwd] = useState(false);
    const [modalOpen, setModalOpen] = useState(false);

    const toggleModal = () => {
        setForgotPwd(false);
        setModalOpen(!modalOpen);
    };

    const handleEmailChange = (e) => {
        setEmail(e.target.value);
    };

    const handleSendEmail = async () => {
        try {
            const payload = {
                forgotpwd: {
                    email: email
                }
            };
            const response = await fetch(`${API_URL}/common/send_forgot_pwd_email.php`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(payload)
            });
            const data = await response.json();
            toggleModal();
            let msg = translations[lang][data.alert.message] + "'" + email + "'!";
            setGrowlMessage(msg, data.alert.type);
        } catch (error) {
            console.error("Error send forgot pwd:", error);
        }
    };


    const handleLogin = async (e) => {
        e.preventDefault();

        try {
            const payload = {
                loginData: {
                    usr: username,
                    pwd: password
                }
            };

            const response = await fetch(`${API_URL}/common/login.php`, {
                method: 'POST',
                headers: {'Content-Type': 'application/json'},
                body: JSON.stringify(payload)
            });

            const data = await response.json();

            if (data.user) {
                onUserChange(data.user);
                toggleModal();
            } else {
                setGrowlMessage(translations[lang][data.msgkey] + '!', 'error');
            }
        } catch (error) {
            console.error('Error during login:', error);
        }
    };

    const handleLogout = () => {
        fetch(`${API_URL}/common/logout.php`);
        onUserChange(null);
        setUsername('');
        setPassword('');
        setGrowlMessage();
    };

    return (
            <>
            {user === null && <Button color="primary" className="m-1" onClick={toggleModal}><FontAwesomeIcon icon={faUser}/>{"   "}{translations[lang].login}</Button>}
            {user !== null && <Button color="primary"  className="m-1" onClick={handleLogout}><FontAwesomeIcon icon={faUser}/>{"   "}{translations[lang].logout}</Button>}
            
            {/*login and forgot password dialog*/}
            <Modal isOpen={modalOpen} toggle={toggleModal}>
                <ModalHeader toggle={toggleModal}>{translations[lang].login}</ModalHeader>
                <ModalBody>
            
                    {/*login*/}
                    {!forgotPwd && <form className="d-flex flex-column align-items-end" onSubmit={handleLogin}>
                        <input
                            id="login_usr"
                            type="text"
                            placeholder={translations[lang].username}
                            className="form-control mb-3" 
                            autoComplete="username"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            required
                            />
                        <input
                            id="login_pwd"
                            type="password"
                            placeholder={translations[lang].password}
                            className="form-control mb-3" 
                            autoComplete="current-password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                            />
                        <div className="d-flex justify-content-between w-100">
                            <Button type="submit" color="primary" onClick={(e) => handleLogin(e)}>{translations[lang].login}</Button>
                            <Button type="button" color="secondary" outline onClick={() => setForgotPwd(true)}>{translations[lang].forgotpwd}</Button>
                        </div>
                    </form>}

                    {/*forgot pwd*/}
                    {forgotPwd && (
                            <>
                            <p>{translations[lang].forgot_pwd_description}</p>
                            <FormGroup floating>
                                <Input
                                    id="forgotPwdEmail"
                                    type="email"
                                    value={email}
                                    onChange={handleEmailChange}
                                    placeholder="Enter your email"/>
                                <Label for="forgotPwdEmail">{translations[lang].forgot_pwd_email}</Label>
                            </FormGroup>
                            <Button color="primary" onClick={handleSendEmail}>{translations[lang].forgot_pwd_email_send}</Button>
                            <Button color="secondary" outline onClick={toggleModal}>{translations[lang].cancel}</Button>
                            </>
                                )}            
                </ModalBody>
            </Modal>            
            </>

            );
};

export default Login;
